export default __webpack_public_path__ + "static/media/crowne-plaza.b01c38a0.jpg";